import styled from 'styled-components';
import { MASKED_TEXT_CLASS } from 'analytics';
import { Skeleton } from 'components';

export const PatientCard = styled.div.attrs<{ $sticky?: boolean }>((props) => ({
  className: [
    'mb-3 rounded-lg border border-border bg-card p-4 shadow-sm',
    props.$sticky ? 'sticky top-20 z-10' : '',
  ]
    .filter(Boolean)
    .join(' '),
}))<{ $sticky?: boolean }>``;

export const PatientDetails = styled.div.attrs({
  className: 'space-y-3 text-base',
})``;

export const PatientContent = styled.div.attrs({
  className: `w-full flex items-baseline gap-2 text-sm font-medium ${MASKED_TEXT_CLASS}`,
})``;

export const PatientHeaderContentCard = styled.div.attrs({
  className: 'rounded-md border border-border bg-card px-2 py-1',
})``;

export const PatientHeaderSkeletonNameBar = styled(Skeleton).attrs({
  className: 'h-4 w-2/5 rounded-full',
})``;

export const PatientHeaderSkeletonIconRow = styled.div.attrs({
  className: 'flex gap-2',
})``;

export const PatientHeaderSkeletonIcon = styled(Skeleton).attrs({
  className: 'h-9 w-9 rounded-md',
})``;
